<div class="lngBtnContainer">
    <a id="btn-FR" href="#" (click)="swithLang($event,'FR')">
        <img class="lng-btn" [src]="frBtnImagePath">
    </a>
    &nbsp;
    <a id="btn-EN" href="#" (click)="swithLang($event,'EN')">
        <img class="lng-btn" [src]="enBtnImagePath">
    </a>
</div>